import { useCallback } from "react";
import { walletApi } from "@/betby/api/services";
import { useNavStore } from "@/betby/store/navStore";
import LogUtil from "@/betby/utils/LogUtil";
import { TRACK_EVENT_CHANGE_TYPE_SPM } from "@/betby/utils/TrackEvents";
import { sendCurrencyChangeMessage } from "@/betby/models/host/unityMessageService";
import analyticsBridge from "@/betby/adapters/analytics/analyticsBridge";

export function useCurrencySwitchViewModel() {
  const { currentMode, toggleCurrency, updateBalance } = useNavStore();
  const isGC = (localStorage.getItem("winburst-mode") || currentMode) === "gc";
  const handleToggle = useCallback(async () => {
    const prevMode = currentMode;
    const nextMode = prevMode === "gc" ? "sc" : "gc";

    try {
      analyticsBridge.track(TRACK_EVENT_CHANGE_TYPE_SPM, {
        src: 516,
        type: prevMode === "gc" ? "2" : "1",
      });
    } catch (error) {
      LogUtil.error(
        "[CurrencySwitchViewModel] Failed to track change_type_spm",
        error,
      );
    }

    toggleCurrency();
    sendCurrencyChangeMessage(nextMode);

    try {
      const res = await walletApi.getBalance();
      if (res.code === 200 && res.data?.wallet_info_usd) {
        const { wallet_info_usd } = res.data;
        const scBalance = wallet_info_usd.cash ?? 0;
        const gcBalance = wallet_info_usd.coin ?? 0;

        updateBalance("sc", scBalance);
        updateBalance("gc", gcBalance);

        LogUtil.info("[CurrencySwitchViewModel] 切换货币后已刷新余额", {
          sc: scBalance,
          gc: gcBalance,
        });
      }
    } catch (error) {
      LogUtil.error("[CurrencySwitchViewModel] 切换货币时刷新余额失败", error);
    }
  }, [currentMode, toggleCurrency, updateBalance]);

  return {
    isGC,
    handleToggle,
  };
}
